export const KEYWORD_LINKER_ATTRIBUTE_NAME = "keyword-linker";
